import React, { useContext } from 'react'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import articleSummaries from '../../data/articleSummaries'
import './articleSummary.scss'

/**
 * Collapsible "Summary" box at the top of an article: the key takeaways in
 * a few bullets. A native <details>, so it works with the keyboard and
 * screen readers, and the text stays in the page for search engines even
 * while the box is closed.
 */
const ArticleSummary = ({ id }) => {
  const { translations: t } = useContext(LanguageContext)
  const points = articleSummaries[id]
  if (!points) return null

  const text = (point, index) => {
    const value = t[`artSum.${id}.${index}`]
    return typeof value === 'string' && value.trim() ? value : point
  }

  return (
    <details className='article-summary'>
      <summary>
        <span className='article-summary-label'>{t.artSummaryLabel || 'Summary'}</span>
        <span className='article-summary-icon' aria-hidden='true' />
      </summary>
      <ul>
        {points.map((point, index) => <li key={index}>{text(point, index)}</li>)}
      </ul>
    </details>
  )
}

export default ArticleSummary
